import Tables from 'src/class/Tables';
import i18n from "src/i18n";

const configTable = () => {
    const Table = { ...Tables.Table };
    Table.tableColumns = [
        {
            prop: 'priority',
            label: i18n.t('grow.priority'),
            minWidth: 50,
            sortable: true,
            align: 'center',
            fixed: true,
        },
        {
            prop: 'schedule',
            label: i18n.t('grow.horary'),
            minWidth: 100,
            sortable: true,
            align: 'left',
            fixed: true,
        },
        {
            prop: 'activity',
            label: i18n.t('grow.activity'),
            minWidth: 100,
            sortable: true,
            align: 'left',
            fixed: true,
        },
        {
            prop: 'time',
            label: i18n.t('grow.time'),
            minWidth: 50,
            sortable: true,
            align: 'center',
            fixed: true,
        },
        {
            prop: 'compliance',
            label: i18n.t('grow.compliance'),
            minWidth: 60,
            sortable: true,
            align: 'center',
            fixed: true,
        },
        {
            prop: 'compliance_score',
            label: i18n.t('grow.compliance_score'),
            minWidth: 50,
            sortable: true,
            align: 'center',
            fixed: true,
        },
    ];
    const Search = { ...Tables.Search };
    return { Table, Search };
};

export default configTable;
